<div class="main-panel" infiniteScroll (scrolled)="onScroll()">
    <ng-template #section></ng-template>
</div>